export interface TutorialStep {
  stepId: string;
  titleKey: string;
  contentKey: string;
  targetSelector?: string;
  spotlightType: 'modal' | 'overlay';
  position?: 'top' | 'bottom' | 'left' | 'right' | 'inside-top' | 'inside-bottom';
}

export const TUTORIAL_STEPS: TutorialStep[] = [
  {
    stepId: 'welcome',
    titleKey: 'welcome',
    contentKey: 'welcome',
    spotlightType: 'modal',
  },
  {
    stepId: 'sidebar',
    titleKey: 'sidebar',
    contentKey: 'sidebar',
    targetSelector: '[data-tutorial-id="sidebar"]',
    spotlightType: 'overlay',
    position: 'right',
  },
  {
    stepId: 'processes',
    titleKey: 'processes',
    contentKey: 'processes',
    targetSelector: '[data-tutorial-id="processes-menu"]',
    spotlightType: 'overlay',
    position: 'right',
  },
  {
    stepId: 'processDescriptionSidebar',
    titleKey: 'processDescriptionSidebar',
    contentKey: 'processDescriptionSidebar',
    targetSelector: '[data-tutorial-id="process-sidebar"]',
    spotlightType: 'overlay',
    position: 'right',
  },
  {
    stepId: 'processDescriptionContent',
    titleKey: 'processDescriptionContent',
    contentKey: 'processDescriptionContent',
    targetSelector: '[data-tutorial-id="process-content"]',
    spotlightType: 'overlay',
    position: 'left',
  },
  {
    stepId: 'triggers',
    titleKey: 'triggers',
    contentKey: 'triggers',
    targetSelector: '[data-tutorial-id="triggers-section"]',
    spotlightType: 'overlay',
    position: 'right',
  },
  {
    stepId: 'executeButton',
    titleKey: 'executeButton',
    contentKey: 'executeButton',
    targetSelector: '[data-tutorial-id="execute-button"]',
    spotlightType: 'overlay',
    position: 'bottom',
  },
  {
    stepId: 'requestExecution',
    titleKey: 'requestExecution',
    contentKey: 'requestExecution',
    targetSelector: '[data-tutorial-id="request-execution-button"]',
    spotlightType: 'overlay',
    position: 'bottom',
  },
  {
    stepId: 'executions',
    titleKey: 'executions',
    contentKey: 'executions',
    targetSelector: '[data-tutorial-id="executions-menu"]',
    spotlightType: 'overlay',
    position: 'right',
  },
  {
    stepId: 'processMapOverview',
    titleKey: 'processMapOverview',
    contentKey: 'processMapOverview',
    spotlightType: 'modal',
  },
  {
    stepId: 'processMapFilters',
    titleKey: 'processMapFilters',
    contentKey: 'processMapFilters',
    targetSelector: '[data-tutorial-id="process-map-filters"]',
    spotlightType: 'overlay',
    position: 'left',
  },
  {
    stepId: 'completion',
    titleKey: 'completion',
    contentKey: 'completion',
    spotlightType: 'modal',
  },
];

export const TUTORIAL_VERSION = '1.2';
